// import { getUserMenuByModuleId } from '@/api/user.js';
export default {
  data(){
    return {
      pageParams: {
        page: 1,
        limit: 10,
        total: 0
      },
      innerBtn: [],
      outerBtn: []
    }
  },
  //fix：页面切换时，表格固定列样式错乱问题
  activated(){
    if(this.$refs.mainTable){
      this.$nextTick(() => {
        this.$refs.mainTable.doLayout();
      });
    }
  },
  created(){
    // getUserMenuByModuleId({
    //   MouduleId: this.$route.meta.moduleId
    // }).then(res => {
    //   this.innerBtn = res.innerBtn;
    //   this.outerBtn = res.outBtn;
    // })
  },
  methods: {
    onBtnClick(eventName,row){
      this[eventName](row);
    },
    handleSizeChange(val) {
      this.pageParams.page = 1;
      this.pageParams.limit = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageParams.page = val;
      this.getData();
    },
    toFilter(){
      this.pageParams.page = 1;
      this.getData();
    },
    //重置筛选
    toReset(){
      this.$refs['filterForm'].resetFields();
      this.toFilter();
    },
  }
}